<template>
  <div class="eventi-main" v-bind:class="{'show-user-likes':usersLikes.length}">
    <div
      id="eventi-container"
      v-if="!!calendar && dataLoaded"
      v-bind:class="[calendar.displayMode===1 ? 'display-week' : 'display-month']"
    >
      <div id="header-data" v-bind:class="containerClasses">
        <div class="week-calendar">
          <div id="mese">
            <i
              class="rds-icon rds-icon-left"
              v-bind:class="{disabled: isCurrentWeek}"
              v-on:tap="showPreviousWeek()"
            ></i>
            <span>{{calendar.monthName}} {{calendar.year}}</span>
            <i class="rds-icon rds-icon-right" v-on:tap="showNextWeek()"></i>
          </div>
          <transition v-bind:name="transitionName" mode="out-in">
            <div class="giorni" v-if="!calendar.updating" v-swipe:onSwipe="{configs:swipeConfigs}">
              <div
                v-for="day in calendar.displayWeek.days"
                v-bind:key="day.startDate"
                v-bind:class="[getCssClasses(day)]"
              >
                <span class="day-number">{{day.number}}</span>
              </div>
            </div>
          </transition>
        </div>
        <div class="month-calendar">
          <div id="mese" v-bind:class="{showMese:calendar.displayMode===1}">
            <i
              class="rds-icon rds-icon-left"
              v-bind:class="{disabled: isCurrentMonth}"
              v-on:tap="showPreviousMonth()"
            ></i>
            <span>{{curMonthName}} {{calendar.year}}</span>
            <i class="rds-icon rds-icon-right" v-on:tap="showNextMonth()"></i>
          </div>
          <transition v-bind:name="transitionName" mode="out-in">
            <div
              class="weeks"
              v-if="!calendar.updating"
              v-swipe:onSwipe="{configs:monthSwipeConfigs}"
            >
              <div
                class="giorni"
                v-for="week in calendar.displayMonth.weeks"
                v-bind:key="week.startDay.getTime()"
                v-bind:style="monthTransform"
              >
                <div
                  v-for="day in week.days"
                  v-bind:key="day.startDate"
                  v-bind:class="[getCssClasses(day)]"
                >
                  <span class="day-number">{{day.number}}</span>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div class="swipe-container" v-swipe:onSwipe="{configs:swipeTopDown}"></div>
        <div id="linea"></div>
      </div>

      <div id="listato-eventi">
        <EventCard
          v-bind:event="event"
          v-for="event in calendar.displayEvents"
          v-bind:key="event.id"
          v-on:showUsersLikes="showUsersLikes"
        ></EventCard>
        <div class="events-likes-container" v-if="!!usersLikes.length">
          <div class="eventi-overlay"></div>
          <div class="events-likes" v-on:tap.self="hideUsersLikes">
            <EventLike
              v-on:close="hideUsersLikes"
              v-bind:event="usersLikesEvent"
              v-bind:users="usersLikes"
            ></EventLike>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import calendarService from '../services/Calendar.service';
import EventCard from '../components/EventCard';
import EventLike from '../components/EventLike';
import store from '../stores';
import swipe from '../directives/swipe.new';
// import enums from '../enums/RdsLife.enums';
import { eventBus } from '../services/EventBus';

// const swipe = new Swipe();
// const swipeRight = new Swipe();

export default {
  name: 'eventi',
  components: { EventCard, EventLike },
  directives: {
    swipe
  },
  data() {
    return {
      calendar: {},
      transitionName: 'slide-right',
      usersLikesEvent: null,
      usersLikes: [],
      containerClasses: [],
      swipeConfigs: [
        { handler: this.showNextWeek },
        { handler: this.showPreviousWeek, direction: 'right' }
      ],
      monthSwipeConfigs: [
        { handler: this.showNextMonth },
        { handler: this.showPreviousMonth, direction: 'right' }
      ],
      swipeTopDown: [
        {
          direction: 'top',
          cssClass: 'no-swipe',
          eventHandler: this.onSwipe,
          endTransitionDuration: 200,
          conditionalCheck: this.swipeTopCheck
        },
        {
          direction: 'bottom',
          cssClass: 'no-swipe',
          eventHandler: this.onSwipe,
          endTransitionDuration: 200,
          conditionalCheck: this.swipeDownCheck
        }
      ]
    };
  },
  methods: {
    getCssClasses(day) {
      let cssClasses = [];
      if (day.events.length > 0) {
        const event = day.events[0];
        cssClasses.push('evento');
        cssClasses.push('evento-' + event.color);
      }
      if (this.isToday(day)) {
        cssClasses.push('today');
      }
      if (!day.isCurrentMonth) {
        cssClasses.push('not-in-month');
      }
      return cssClasses;
    },
    isToday(calendarDay) {
      return (
        new Date() > calendarDay.startDate && new Date() < calendarDay.endDate
      );
    },
    showPreviousWeek() {
      if (this.isCurrentWeek) {
        return;
      }
      this.transitionName = 'slide-left';
      this.calendar.showPrevWeek();
    },
    swipeTopCheck() {
      return this.calendar.displayMode === 0;
    },
    swipeDownCheck() {
      return this.calendar.displayMode === 1;
    },
    showNextWeek() {
      this.transitionName = 'slide-right';
      this.calendar.showNextWeek();
    },
    showPreviousMonth() {
      if (this.isCurrentMonth) {
        return;
      }
      this.transitionName = 'slide-left';
      this.calendar.showPrevMonth();
    },
    showNextMonth() {
      this.transitionName = 'slide-right';
      this.calendar.showNextMonth();
    },
    showUsersLikes(event) {
      const userIds = event.likes;
      document.getElementsByClassName('main')[0].scroll(0, 0);
      store
        .getAll('rdsUser')
        .then(users => users.filter(u => userIds.indexOf(u.id) !== -1))
        .then(users => {
          this.usersLikes = users;
          this.usersLikesEvent = event;
        });
    },
    hideUsersLikes() {
      this.usersLikes = [];
    },
    onSwipe(event, direction) {
      if (event === 'swipe-handling') {
        topBottomSwipeHandling = true;
      }
      if (event === 'swipingEnd' && !topBottomSwipeHandling) {
        const classesToRemove = [
          'swiping',
          'swiping-bottom',
          'swiping-top',
          'swipe-handling',
          'swipe-handling-bottom',
          'swipe-handling-top'
        ];
        this.containerClasses = this.containerClasses.filter(
          c => classesToRemove.indexOf(c) === -1
        );
      } else if (event === 'swipe-handled') {
        // console.log('swipe-handled');

        const classesToRemove = [
          'swiping',
          'swiping-bottom',
          'swiping-top',
          'swipe-handling',
          'swipe-handling-bottom',
          'swipe-handling-top'
        ];
        // debugger;
        this.containerClasses = this.containerClasses.filter(
          c => classesToRemove.indexOf(c) === -1
        );
        if (direction === 'bottom') {
          this.calendar.displayMode = 0;
        } else {
          this.calendar.displayMode = 1;
        }

        topBottomSwipeHandling = false;
      } else {
        if (this.containerClasses.indexOf(event) === -1) {
          this.containerClasses.push(event);
        }
        if (
          !!direction &&
          this.containerClasses.indexOf(`${event}-${direction}`) === -1
        ) {
          this.containerClasses.push(`${event}-${direction}`);
        }
      }
    }
  },
  computed: {
    dataLoaded() {
      return !!this.calendar ? this.calendar.dataLoaded : false;
    },
    curMonthName() {
      return new Date(
        this.calendar.displayMonth.displayDay
      ).toLocaleString('it-it', { month: 'long' });
    },
    isCurrentMonth() {
      const today = new Date();
      today.setDate(1);
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      const curWeekMonday = _getMonday(today);
      const week = this.calendar.displayMonth.weeks[0];
      const startDay = week.startDay;
      startDay.setMilliseconds(0);
      return startDay.getTime() === curWeekMonday.getTime();
    },
    isCurrentWeek() {
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      const curWeekMonday = _getMonday(today);
      const week = this.calendar.displayWeek;
      const startDay = week.startDay;
      startDay.setMilliseconds(0);
      return startDay.getTime() === curWeekMonday.getTime();
    },
    monthTransform() {
      if (this.calendar.displayMode === 0) {
        const transformPx = 0;
        return `transform: translateY(calc(-${transformPx}px + var(--swipe-diff-v)));`;
      }
      const weeks = this.calendar.displayMonth.weeks;
      const displayDay = this.calendar.displayMonth.displayDay;
      let transformIdx = 0;
      for (let i = 0; i < weeks.length; i++) {
        const week = weeks[i];
        // console.log(week);
        if (
          displayDay.getTime() >= week.startDay.getTime() &&
          displayDay.getTime() <= week.endDay.getTime()
        ) {
          transformIdx = i;
          break;
        }
      }
      const transformPx = transformIdx * 44;
      return `transform: translateY(calc(-${transformPx}px + var(--swipe-diff-v)));`;
    }
  },
  mounted() {
    const day = this.$route.query.day;
    const usersPromise = store.getAll('rdsUser');
    eventBus.$emit('updating');
    usersPromise.then(users => {
      calendarService.getGCalendarEvents(users).then(events => {
        this._events = events;
        const calendar = calendarService;
        calendar.init(events, day);
        this.calendar = calendar;
        eventBus.$emit('updated');
      });
    });

    // const p1 = calendarService.getGCalendarEvents();
    // const p2 = store.getAll(enums.modelTypes.CALENDAR_EVENT);
    // eventBus.$emit('updating');
    // Promise.all([p1, p2]).then(values => {
    //   const events = values[0];
    //   this._events = events;
    //   eventBus.$emit('updated');
    //   const calendar = calendarService;
    //   calendar.init(events, day);
    //   this.calendar = calendar;
    // });
    // store.getAll(enums.modelTypes.CALENDAR_EVENT).then(events => {
    //   this._events = events;
    //   console.log(this._events);
    //   const calendar = calendarService;
    //   calendar.init(events);
    //   this.calendar = calendar;
    // });
  }
};
let topBottomSwipeHandling = false;
function _getMonday(date) {
  const curr = new Date(date);
  const day = curr.getDay();
  const diff = curr.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(curr.setDate(diff));
}
</script>
<style lang="scss" scoped>
.eventi-main {
  position: relative;
  padding-bottom: 32px;
  &.show-user-likes {
    overflow: hidden;
  }
}
#header-data {
  background-color: #ffffff;
  border-radius: 0 0 10px 10px;
  border: #efefef solid 1px;
  position: relative;
  // position: sticky;
  // top: 0;
  // z-index: 1;
  @include shadow-bottom;
  #mese {
    display: flex;
    justify-content: space-between;
    padding: 30px 20px 0;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600;

    i {
      color: #000000;
      font-size: 0.8em;
      &.rds-icon-left.disabled {
        color: #e4e8ea;
      }
    }
    p {
      text-transform: uppercase;
      font-weight: 600;
    }
  }
  .giorni {
    display: flex;
    padding: 30px 20px 15px 20px;
    justify-content: space-between;
    & > div {
      display: flex;
      align-content: center;
      /* align-items: center; */
      span {
        height: 44px;
        width: 44px;
        text-align: center;
        display: inline-block;
      }
    }
    .day-number {
      margin: 0;
    }
    .not-in-month .day-number {
      color: rgba(96, 125, 139, 0.62);
    }
    .today {
      text-align: center;
      height: auto;
      .day-number {
        width: 18px;
        height: 18px;
        display: inline-block;
        border: 3px solid $main-sky;
        border-radius: 50%;
        position: relative;
        top: -11px;
        padding: 8px;
      }
    }
    .evento {
      text-align: center;
      height: auto;
      .day-number {
        width: 18px;
        height: 18px;
        display: inline-block;
        border: 3px solid #6ab44a;
        border-radius: 50%;
        position: relative;
        top: -11px;
        padding: 8px;
      }
      &.spettacolo .day-number {
        border: 3px solid #cb4242;
      }
      @each $label, $color in $calendar-colors {
        &.evento-#{$label} .day-number {
          border-color: $color;
          border-color: #33b679;
        }
      }
      span {
        width: 18px;
        height: 18px;
        display: inline-block;
      }
    }
  }
}
#linea {
  width: 32px;
  border-top: 3px solid #acacac;
  margin: 5px auto 20px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.event-card {
  margin: 20px 21px 0;
}
.events-likes-container,
.eventi-overlay,
.events-likes {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 1;
}
.eventi-overlay {
  opacity: 0.4;
  background-color: #000000;
}
.swipe-container {
  position: absolute;
  width: 100%;
  height: 50px;
  bottom: 0;
  z-index: 1;
}
.display-month #header-data {
  min-height: 330px;
}
#header-data {
  // transition: min-height 0.1s;
  min-height: 165px;
  &.swiping-top {
    min-height: calc(330px + var(--swipe-diff-v));
  }

  &.swiping-bottom {
    min-height: calc(165px + var(--swipe-diff-v));
  }
  &.swipe-handling {
    transition: min-height 0.5s;
    min-height: 0;
    // transition: min-height 3s;
  }
  &.swipe-handling-top {
    transition: min-height 0.3s;
    // min-height: 0;
    .month-calendar {
      position: absolute;
      width: 100%;
      opacity: 0;
      max-height: 100%;
      overflow: hidden;
    }
  }
  &.swipe-handling-top {
    min-height: 165px;
  }
  &.swipe-handling-bottom {
    min-height: 330px;
  }
}
#header-data {
  .month-calendar {
    #mese {
      padding-bottom: 30px;
    }
    .giorni {
      padding: 0 20px 0 20px;
    }
  }
}
.display-week {
  .month-calendar {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    pointer-events: none;
    #mese {
      visibility: hidden;
    }
    .weeks {
      max-height: calc(44px + var(--swipe-diff-v));
      overflow: hidden;
    }
  }
  .swipe-handling-bottom {
    .month-calendar {
      transition: opacity 0.2s;
      opacity: 1;
    }
    .weeks {
      transition: max-height 0.2s;
      max-height: 220px;
      overflow: hidden;
    }
    .giorni {
      transform: translateY(0) !important;
    }
  }
  .swiping-bottom {
    .week-calendar {
      .giorni {
        opacity: 0;
      }
    }
  }
  .swiping-bottom {
    .month-calendar {
      opacity: var(--swipe-diff-percentage-v);
    }
    &.swipingEnd .month-calendar {
      opacity: 1;
    }
  }
}

.display-month {
  .month-calendar {
    margin: 0 0 30px;
  }
  .week-calendar {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    pointer-events: none;
    .giorni {
      opacity: var(--swipe-diff-percentage-v);
    }
  }
  .swiping-top {
    .month-calendar {
      opacity: calc(1 + var(--swipe-diff-percentage-v));
      .weeks {
        max-height: calc(220px + var(--swipe-diff-v);
        overflow: hidden;
      }
    }
    .week-calendar {
      opacity: 1;
      .giorni {
        opacity: var(--swipe-diff-percentage-v);
      }
    }
  }
  .swipe-handling-top {
    #header-data {
      // transition: none;
      min-height: 165px;
    }
    .month-calendar {
      opacity: 1;
    }
    .week-calendar {
      opacity: 1;
      .giorni {
        opacity: 1;
      }
    }
  }
  .swipe-handling {
    #header-data {
      min-height: 165px;
    }
  }
}
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.2s;
}

.slide-right-enter {
  transform: translateX(100%);
}

.slide-right-leave-to {
  transform: translateX(-100%);
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.2s;
}

.slide-left-enter {
  transform: translateX(-100%);
}

.slide-left-leave-to {
  transform: translateX(100%);
}
</style>
